import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
	clientPrefix: "VITE_",
	client: {
		VITE_BACKEND_URL: z.string().url(),
		VITE_SENTRY_DSN: z.string().url(),
	},

	runtimeEnv: import.meta.env,
});
